export class PasswordValidationModel {
  length!: boolean;
  uppercase!: boolean;
  lowercase!: boolean;
  digit!: boolean;
  special!: boolean;
  valid!:boolean;
}
